// extracted by mini-css-extract-plugin
export var card = "_s9-0";
export var details = "_s9-1";